import { render, staticRenderFns } from "./EmailLists.vue?vue&type=template&id=35a38d61&scoped=true&"
import script from "./EmailLists.vue?vue&type=script&lang=js&"
export * from "./EmailLists.vue?vue&type=script&lang=js&"
import style0 from "./EmailLists.vue?vue&type=style&index=0&id=35a38d61&lang=postcss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../../../../opt/jenkins_node_modules/doris/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35a38d61",
  null
  
)

export default component.exports